// src/bridge/refreshJWT.ts
import { readCookie } from "@zapier/cookies";
var REFRESH_PROMISE_KEY = "__zapier_identity_refresh_promise__";
var getInFlightPromise = () => {
  return globalThis[REFRESH_PROMISE_KEY] ?? null;
};
var setInFlightPromise = (promise) => {
  globalThis[REFRESH_PROMISE_KEY] = promise;
};
var performRefresh = async () => {
  try {
    const csrfToken = readCookie("csrftoken");
    if (!csrfToken) {
      console.warn("No CSRF token found for JWT refresh");
      return 0;
    }
    const refreshResponse = await fetch(`/api/v4/jwt/refresh`, {
      credentials: "include",
      method: "POST",
      mode: "cors",
      headers: { "X-CSRFToken": csrfToken }
    });
    return refreshResponse.status;
  } catch (error) {
    console.error("JWT refresh failed:", error);
    return 0;
  }
};
var refreshSubpathJWTStatus = async () => {
  const existing = getInFlightPromise();
  if (existing) {
    return existing;
  }
  const promise = performRefresh().finally(() => {
    setInFlightPromise(null);
  });
  setInFlightPromise(promise);
  return promise;
};
var refreshSubpathJWT = async () => {
  const status = await refreshSubpathJWTStatus();
  return status === 200 || status === 429;
};

export {
  refreshSubpathJWTStatus,
  refreshSubpathJWT
};
//# sourceMappingURL=chunk-YUMKHUP4.mjs.map